import * as Yup from 'yup';
import { isValidPesel } from '../../helpers/validation';

export const sharedSchema = {
    personalInformation: Yup.object().shape({
        name: Yup.string().required('Pole wymagane'),
        surname: Yup.string().required('Pole wymagane'),
        email: Yup.string().email('Niepoprawny adres email').required('Pole wymagane'),
        phone: Yup.string().required('Pole wymagane'),
        city: Yup.string().required('Pole wymagane'),
        zipCode: Yup.string().required('Pole wymagane'),
        address: Yup.string().required('Pole wymagane'),
        houseNumber: Yup.string().required('Pole wymagane'),
        pesel: Yup.string()
            .required('Pesel jest wymagany')
            .test('pesel', 'Nieprawidłowy pesel.', (value) => isValidPesel(value)),
    }),
};
